import React from 'react';

interface SectionSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  clearLabel: string;
}

/** The filter box shared by every task list inside a detail pane. */
const SectionSearch: React.FC<SectionSearchProps> = ({
  value,
  onChange,
  placeholder,
  clearLabel,
}) => (
  <div className="asset-section__search">
    <i className="uil uil-search asset-section__search-icon" />
    <input
      type="text"
      className="asset-section__search-input"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {value && (
      <button
        type="button"
        className="asset-section__search-clear"
        title={clearLabel}
        aria-label={clearLabel}
        onClick={() => onChange('')}
      >
        <i className="uil uil-times" />
      </button>
    )}
  </div>
);

export default SectionSearch;
